import { A } from "@solidjs/router";
import { MainSlider } from "../components/main-slider";
import { Img } from "../components/universal/image";

export const LogoSlider = () =>
    {
        return (
            <>
                <div class="logo-container">
                    <div class="logo-cell">
                        <a href="/">
                            <Img class="img-responsive" src={"/Media/Elements/arc-logo4.jpg"} width={951} height={303} mode="crop" />
                        </a>
                    </div>
                    <div class="slider-cell">
                        <div style="background-color: #333; color: darkgoldenrod; ">
                            <div class="slick" style="height: 100%;">
                                <div class="slide">
                                    <figure>
                                        <A href="/">
                                            <Img
                                                src="/ContentSection/23/Images/2bec1a89-03f2-47c9-b812-b99ec9afcace.jpg"
                                                width={951} height={303} mode="crop"
                                                style="width: 951px; height: 303px;"
                                                class="img-responsive"
                                            />
                                        </A>
                                        <figcaption>
                                            
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div class="logo-container">
                    <div class="logo-cell">
                        <a href="/">
                            <Img class="img-responsive" src={"/Media/Elements/arc-logo4.jpg"} w={951} h={303} mode="crop" />
                        </a>
                    </div>
                    <div class="slider-cell">
                        <MainSlider />
                    </div>
                </div> */}
            </>
        );
    };